var React = require('react');

function SmartscreenInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"2"},[React.createElement("path",{"d":"M46 48h2l9 13H7l9-13h2","key":0}),React.createElement("path",{"d":"M22 45h20v6a2 2 0 0 1-2 2H24a2 2 0 0 1-2-2v-6z","key":1}),React.createElement("rect",{"width":"28","height":"42","x":"18","y":"3","rx":"2","key":2}),React.createElement("rect",{"width":"20","height":"34","x":"22","y":"7","rx":"1","key":3})]));
}

SmartscreenInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = SmartscreenInline;

SmartscreenInline.default = SmartscreenInline;
